import { apiSlice } from '../../api';
import type {
  GetBankAccountsDTO,
  GetBankAccountsResult,
  UpdateBankAccountDTO,
  UpdateBankAccountResult,
  UpdateBankAccountStateDTO,
  UpdateBankAccountStateResult,
} from './types';

export const adminBankAccountsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getBankAccounts: build.query<GetBankAccountsResult, GetBankAccountsDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/bank-accounts`,
          method: 'GET',
        }),
        providesTags: ['BankAccounts'],
      }),

      updateBankAccount: build.mutation<UpdateBankAccountResult, UpdateBankAccountDTO>({
        query: ({ profileUid, accountId, body }) => ({
          url: `/admin/v1/profiles/${profileUid}/bank-accounts/${accountId}`,
          method: 'PUT',
          body,
        }),
        // invalidatesTags: ['BankAccounts'],
      }),

      updateBankAccountState: build.mutation<
        UpdateBankAccountStateResult,
        UpdateBankAccountStateDTO
      >({
        query: ({ profileUid, accountId, body }) => ({
          url: `/admin/v1/profiles/${profileUid}/bank-accounts/${accountId}/state`,
          method: 'PUT',
          body,
        }),
        // invalidatesTags: ['BankAccounts'],
      }),
    };
  },
});

export const { useLazyGetBankAccountsQuery } = adminBankAccountsEndpoints;
export const { useUpdateBankAccountMutation } = adminBankAccountsEndpoints;
export const { useUpdateBankAccountStateMutation } = adminBankAccountsEndpoints;

export type AdminBankAccountsController = typeof adminBankAccountsEndpoints;
